<div [class.is-filtered]="isFiltered">
  <mat-form-field>
    <mat-label>Filter</mat-label>
    <input [formControl]="element" [matAutocomplete]="filterAutocomplete" matInput
           #filterAutocompleteTrigger type="text">
    <mat-autocomplete #filterAutocomplete="matAutocomplete"
                      [displayWith]="formatAutocomplete"
                      class="company-autocomplete">
      <mat-optgroup *ngIf="suggestionString" label="Zoeken">
        <mat-option [value]="suggestionString">{{ suggestionString.name }}</mat-option>
      </mat-optgroup>
      <mat-optgroup *ngIf="suggestionTypes.length" label="Onderwerp">
        <mat-option *ngFor="let option of suggestionTypes" [value]="option">
          {{ option.name }}
        </mat-option>
      </mat-optgroup>
      <mat-optgroup *ngIf="suggestionCompanies.length" label="Veroorzaker">
        <mat-option *ngFor="let option of suggestionCompanies" [value]="option" class="location">
          {{ option.name }}<br>
          <span>{{ option.location }}</span>
        </mat-option>
      </mat-optgroup>
    </mat-autocomplete>
    <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
  </mat-form-field>
  <button (click)="clearFilterButton()" [class.show]="isFiltered" mat-icon-button type="button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
